import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environment';
import { initSentryErrorTracking } from '@lite-workspace/shared/services';
import { configurePsdRenderWasmUrl } from '@lite-workspace/shared/psd-render-wasm';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

initSentryErrorTracking({ dsn: environment.sentryDsn, environment: environment.sentryEnvironment, app: 'admin' });

configurePsdRenderWasmUrl('/psd_render_bg.wasm');

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
